module.exports = __webpack_public_path__ + "img/5.a316e5c0.png";